export default __webpack_public_path__ + "static/media/baby-35.436680a9.svg";